import React from 'react';
import PropTypes from 'prop-types';
import { EiqButton, EiqSpinner } from 'eiq-storybook';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SIGN_IN } from 'src/routes/routes';
import GuestScreen from './GuestScreen';

export const ProcessingRequestScreen = ({ showLoginButton = true }) => {
  const { t } = useTranslation();

  return <GuestScreen>
    <h2 className="subHeader">{t('SSO_LOADING_MESSAGE', { defaultValue: 'We are processing your request' })}</h2>
    <EiqSpinner caption={t('PLEASE_WAIT', { defaultValue: 'Please wait...' })} />
    {showLoginButton && (
        <Link className="login-link" to={SIGN_IN}>
            <EiqButton
                aria-label="login"
                id="ssologin"
                label={t('SIGN_IN', { defaultValue: 'Login' })}
                variant="btn--outline-link" 
            />
        </Link>
    )}
  </GuestScreen>
};

ProcessingRequestScreen.propTypes = {
  showLoginButton: PropTypes.bool,
};


